var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.665 0H1.335A1.312 1.312 0 000 1.313v11.374A1.312 1.312 0 001.334 14h11.331a1.313 1.313 0 001.334-1.313V1.357A1.313 1.313 0 0012.665 0zm-9.1 2.669a1.01 1.01 0 110 2.021 1.01 1.01 0 010-2.021zm1.103 8.68H2.647V5.324h1.999l.022 6.025zm7.323 0h-1.968V8.203c0-.792-.224-1.312-.941-1.312a1.08 1.08 0 00-1.01.713 1.43 1.43 0 00-.066.477v3.285H5.972s.026-5.495 0-6.046h2.034v.805a1.969 1.969 0 011.78-.971c1.313 0 2.188 1.01 2.188 2.813l.017 3.382z",
    clipRule: "evenodd"
  })));
}

export default SvgLinkedin;